(() => {
  if (window.__SQ_SLIDER_PERFORMANCE__) return;
  window.__SQ_SLIDER_PERFORMANCE__ = true;

  const CONTROL = '[data-sq-rebuilt-prev],[data-sq-rebuilt-next]';

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest(CONTROL) : null;
    if (!(button instanceof HTMLButtonElement)) return;

    const section = button.closest('[data-sq-rebuilt-slider]');
    const track = section?.querySelector('[data-sq-rebuilt-track]');
    const card = track?.querySelector('[data-sq-rebuilt-card]');
    if (!(track instanceof HTMLElement) || !(card instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const styles = getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const direction = button.matches('[data-sq-rebuilt-prev]') ? -1 : 1;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'auto' });
  }, true);
})();
